module.exports = __webpack_public_path__ + "static/img/advertisement03.b4a367ba.jpg";